module.exports = __webpack_public_path__ + "img/robito.e6d63085.png";